<div class="footer-bg py-4">
  <div class="container">
    <div id="footer-container" class="d-flex gap-4">
      <div class="footer-item-container d-flex gap-4">
        <div class="footer-item">
          <div class="company-info">
            <span class="company-info--title">Kivitelező cég</span>
            <hr />
            <span class="company-info--text">Buj Battery Kft.</span>
            <span class="company-info--text">1027 Budapest, Bem József utca 1/B</span>
            <span class="company-info--text">Adószám: 27517176-2-41</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
